function padDatePart(value: number): string {
  return String(value).padStart(2, '0')
}

export function formatExportDateTime(date: Date = new Date()): string {
  const year = date.getFullYear()
  const month = padDatePart(date.getMonth() + 1)
  const day = padDatePart(date.getDate())
  const hours = padDatePart(date.getHours())
  const minutes = padDatePart(date.getMinutes())
  const seconds = padDatePart(date.getSeconds())
  return `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`
}

export function sanitizeExportFileBase(name: string): string {
  const sanitized = name
    .trim()
    .replace(/[<>:"/\\|?*]/g, '_')
    .replace(/\s+/g, '_')
    .substring(0, 100)
  return sanitized || 'untitled'
}

export function buildDatedExportFilename(
  projectName: string,
  extension: string,
  exportedAt: Date = new Date(),
): string {
  const normalizedExtension = extension.startsWith('.') ? extension : `.${extension}`
  return `${sanitizeExportFileBase(projectName)}_${formatExportDateTime(exportedAt)}${normalizedExtension}`
}
